var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"inset":"","label":("" + (_vm.switch1  === true ? ("" + _vm.OnName) : ("" + _vm.OffName)))},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }